<template>
    <v-layout class="component-wrap">
        <Events />
    </v-layout>
</template>

<script>
import Events from '@/components/view_blocks/Events/Events_wrap.vue';

export default {
  components: {
    Events,
  },
};
</script>
